/**
 * Client-side mirror of server training-type compatibility (catalog + legacy בר/מכשיר).
 * @param {string} userType
 * @param {string} sessionType
 * @param {Array<{ name: string, compatibility_group: number }>} catalog - from GET /training-types
 */
export function areTrainingTypesCompatible(userType, sessionType, catalog) {
  if (userType === sessionType) {
    return true;
  }
  if (catalog && catalog.length > 0) {
    const u = catalog.find((t) => t.name === userType);
    const s = catalog.find((t) => t.name === sessionType);
    if (u && s) {
      return Number(u.compatibility_group) === Number(s.compatibility_group);
    }
  }
  const legacy = ['בר', 'מכשיר'];
  return legacy.includes(userType) && legacy.includes(sessionType);
}
